module.exports = __webpack_public_path__ + "img/10094_logo-QualiPAC-2022-RGE.b339e119.jpg";